import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import ContactPage from '../views/Contact.vue'
import ChiSiamoPage from '../views/ChiSiamo.vue'
import ChatbotTicinoPage from '../views/ChatbotTicino.vue'
import ChatbotPage from '../views/Chatbot.vue'
import WebsitePage from '../views/Website.vue'
import WebsiteTicinoPage from '../views/WebsiteTicino.vue'
import CreazioneSitiWebLuganoPage from '../views/CreazioneSitiWebLugano.vue'
import AgenziaWebTicinoPage from '../views/AgenziaWebTicino.vue'
import SviluppoSitiInternetTicinoPage from '../views/SviluppoSitiInternetTicino.vue'
import SeoLuganoTicinoPage from '../views/SeoLuganoTicino.vue'
import MarketingDigitaleTicinoPage from '../views/MarketingDigitaleTicino.vue'
import RealizzazioneEcommerceLuganoPage from '../views/RealizzazioneEcommerceLugano.vue'
import WebDesignLocarnoPage from '../views/WebDesignLocarno.vue'
import AgenziaSeoTicinoPage from '../views/AgenziaSeoTicino.vue'
import CreazioneSitiWebBellinzonaPage from '../views/CreazioneSitiWebBellinzona.vue'
import SviluppoAppTicinoPage from '../views/SviluppoAppTicino.vue'
import GestionaliOdooLuganoPage from '../views/GestionaliOdooLugano.vue'
import SocialMediaManagementTicinoPage from '../views/SocialMediaManagementTicino.vue'
import ProduzioneVideoAziendaliTicinoPage from '../views/ProduzioneVideoAziendaliTicino.vue'
import PosizionamentoMotoriRicercaLuganoPage from '../views/PosizionamentoMotoriRicercaLugano.vue'
import SitiWebResponsiveTicinoPage from '../views/SitiWebResponsiveTicino.vue'
import DigitalMarketingStrategieLuganoPage from '../views/DigitalMarketingStrategieLugano.vue'
import OttimizzazioneSeoLocarnoPage from '../views/OttimizzazioneSeoLocarno.vue'
import EcommerceSviluppoTicinoPage from '../views/EcommerceSviluppoTicino.vue'
import WebAgencyMendrisioPage from '../views/WebAgencyMendrisio.vue'
import SoftwareGestionaliBellinzonaPage from '../views/SoftwareGestionaliBellinzona.vue'
import CampagnePubblicitarieOnlineTicinoPage from '../views/CampagnePubblicitarieOnlineTicino.vue'
import DesignSitiWebLuganoPage from '../views/DesignSitiWebLugano.vue'
import SeoConsultingTicinoPage from '../views/SeoConsultingTicino.vue'
import RealizzazioneApplicazioniMobileLocarnoPage from '../views/RealizzazioneApplicazioniMobileLocarno.vue'
import GestioneSocialMediaLuganoPage from '../views/GestioneSocialMediaLugano.vue'
import VideoMarketingTicinoPage from '../views/VideoMarketingTicino.vue'
import SitiInternetProfessionaliBellinzonaPage from '../views/SitiInternetProfessionaliBellinzona.vue'
import PosizionamentoGoogleMendrisioPage from '../views/PosizionamentoGoogleMendrisio.vue'
import AgenziaMarketingDigitaleChiassoPage from '../views/AgenziaMarketingDigitaleChiasso.vue'
import SviluppoSoftwarePersonalizzatiTicinoPage from '../views/SviluppoSoftwarePersonalizzatiTicino.vue'
import AiChatbotDevelopmentServicesSwitzerlandPage from '../views/AiChatbotDevelopmentServicesSwitzerland.vue'
import AiChatbotSwitzerlandPage from '../views/AiChatbotSwitzerland.vue'
import WebDesignLuganoPage from '../views/WebDesignLugano.vue'
import SitiWebAvvocatiPage from '../views/SitiWebAvvocati.vue'
import SitiWebFisioterapiaPage from '../views/SitiWebFisioterapia.vue'
import UTablePage from '../views/UTable.vue'
import QuoteWebsitePage from '../views/QuoteWebsite.vue'
import OffertaPMIPage from '../views/OffertaPMI.vue'
import AutomazioniAiPage from '../views/AutomazioniAi.vue'
import AiAgentInfrastructurePage from '../views/AiAgentInfrastructure.vue'
import AiAgentInfrastructureEnglishPage from '../views/AiAgentInfrastructureEnglish.vue'
import PortfolioPage from '../views/Portfolio.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      title: 'homePage.meta.title',
      description: 'homePage.meta.description',
      keywords: 'homePage.meta.keywords'
    }
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage,
    meta: {
      title: 'contactPage.meta.title',
      description: 'contactPage.meta.description',
      keywords: 'contactPage.meta.keywords'
    }
  },
  {
    path: '/chi-siamo',
    name: 'ChiSiamoPage',
    component: ChiSiamoPage,
    meta: {
      title: 'chiSiamoPage.meta.title',
      description: 'chiSiamoPage.meta.description',
      keywords: 'chiSiamoPage.meta.keywords'
    }
  },
  {
    path: '/chatbot',
    name: 'ChatbotPage',
    component: ChatbotPage,
    meta: {
      title: 'chatbotPage.meta.title',
      description: 'chatbotPage.meta.description',
      keywords: 'chatbotPage.meta.keywords'
    }
  },
  {
    path: '/chatbot-ticino',
    name: 'ChatbotTicinoPage',
    component: ChatbotTicinoPage,
    meta: {
      title: 'chatbotTicinoPage.meta.title',
      description: 'chatbotTicinoPage.meta.description',
      keywords: 'chatbotTicinoPage.meta.keywords'
    }
  },
  {
    path: '/website',
    name: 'WebsitePage',
    component: WebsitePage,
    meta: {
      title: 'websitePage.meta.title',
      description: 'websitePage.meta.description',
      keywords: 'websitePage.meta.keywords'
    }
  },
  {
    path: '/portfolio',
    name: 'PortfolioPage',
    component: PortfolioPage,
    meta: {
      title: 'Portfolio Siti Web | ciobai.ch',
      description: 'Scopri i progetti e gli esempi di siti web realizzati da ciobai.ch.',
      keywords: 'portfolio siti web, progetti web, esempi siti web, realizzazione siti web'
    }
  },
  {
    path: '/automazioni-ai',
    name: 'AutomazioniAiPage',
    component: AutomazioniAiPage,
    meta: {
      title: 'Automazioni AI per Aziende | ciobai.ch',
      description: 'Automazioni AI per servizio clienti, agenti vocali, processi, marketing e lead generation. Soluzioni su misura per scalare il business.',
      keywords: 'automazioni ai, agenti vocali ai, automazione processi aziendali, marketing automation ai, lead generation ai'
    }
  },
  {
    path: '/website-ticino',
    name: 'WebsiteTicinoPage',
    component: WebsiteTicinoPage,
    meta: {
      title: 'websiteTicinoPage.meta.title',
      description: 'websiteTicinoPage.meta.description',
      keywords: 'websiteTicinoPage.meta.keywords'
    }
  },
  {
    path: '/preventivo-sito-web',
    name: 'QuoteWebsitePage',
    component: QuoteWebsitePage,
    meta: {
      title: 'quoteWebsitePage.meta.title',
      description: 'quoteWebsitePage.meta.description',
      keywords: 'quoteWebsitePage.meta.keywords'
    }
  },
  {
    path: '/creazione-siti-web-lugano',
    name: 'CreazioneSitiWebLuganoPage',
    component: CreazioneSitiWebLuganoPage,
    meta: {
      title: 'creazioneSitiWebLuganoPage.meta.title',
      description: 'creazioneSitiWebLuganoPage.meta.description',
      keywords: 'creazioneSitiWebLuganoPage.meta.keywords'
    }
  },
  {
    path: '/agenzia-web-ticino',
    name: 'AgenziaWebTicinoPage',
    component: AgenziaWebTicinoPage,
    meta: {
      title: 'agenziaWebTicinoPage.meta.title',
      description: 'agenziaWebTicinoPage.meta.description',
      keywords: 'agenziaWebTicinoPage.meta.keywords'
    }
  },
  {
    path: '/sviluppo-siti-internet-ticino',
    name: 'SviluppoSitiInternetTicinoPage',
    component: SviluppoSitiInternetTicinoPage,
    meta: {
      title: 'sviluppoSitiInternetTicinoPage.meta.title',
      description: 'sviluppoSitiInternetTicinoPage.meta.description',
      keywords: 'sviluppoSitiInternetTicinoPage.meta.keywords'
    }
  },
  {
    path: '/seo-lugano-ticino',
    name: 'SeoLuganoTicinoPage',
    component: SeoLuganoTicinoPage,
    meta: {
      title: 'seoLuganoTicinoPage.meta.title',
      description: 'seoLuganoTicinoPage.meta.description',
      keywords: 'seoLuganoTicinoPage.meta.keywords'
    }
  },
  {
    path: '/marketing-digitale-ticino',
    name: 'MarketingDigitaleTicinoPage',
    component: MarketingDigitaleTicinoPage,
    meta: {
      title: 'marketingDigitaleTicinoPage.meta.title',
      description: 'marketingDigitaleTicinoPage.meta.description',
      keywords: 'marketingDigitaleTicinoPage.meta.keywords'
    }
  },
  {
    path: '/realizzazione-ecommerce-lugano',
    name: 'RealizzazioneEcommerceLuganoPage',
    component: RealizzazioneEcommerceLuganoPage,
    meta: {
      title: 'realizzazioneEcommerceLuganoPage.meta.title',
      description: 'realizzazioneEcommerceLuganoPage.meta.description',
      keywords: 'realizzazioneEcommerceLuganoPage.meta.keywords'
    }
  },
  {
    path: '/web-design-locarno',
    name: 'WebDesignLocarnoPage',
    component: WebDesignLocarnoPage,
    meta: {
      title: 'webDesignLocarnoPage.meta.title',
      description: 'webDesignLocarnoPage.meta.description',
      keywords: 'webDesignLocarnoPage.meta.keywords'
    }
  },
  {
    path: '/agenzia-seo-ticino',
    name: 'AgenziaSeoTicinoPage',
    component: AgenziaSeoTicinoPage,
    meta: {
      title: 'agenziaSeoTicinoPage.meta.title',
      description: 'agenziaSeoTicinoPage.meta.description',
      keywords: 'agenziaSeoTicinoPage.meta.keywords'
    }
  },
  {
    path: '/creazione-siti-web-bellinzona',
    name: 'CreazioneSitiWebBellinzonaPage',
    component: CreazioneSitiWebBellinzonaPage,
    meta: {
      title: 'creazioneSitiWebBellinzonaPage.meta.title',
      description: 'creazioneSitiWebBellinzonaPage.meta.description',
      keywords: 'creazioneSitiWebBellinzonaPage.meta.keywords'
    }
  },
  {
    path: '/sviluppo-app-ticino',
    name: 'SviluppoAppTicinoPage',
    component: SviluppoAppTicinoPage,
    meta: {
      title: 'sviluppoAppTicinoPage.meta.title',
      description: 'sviluppoAppTicinoPage.meta.description',
      keywords: 'sviluppoAppTicinoPage.meta.keywords'
    }
  },
  {
    path: '/gestionali-odoo-lugano',
    name: 'GestionaliOdooLuganoPage',
    component: GestionaliOdooLuganoPage,
    meta: {
      title: 'gestionaliOdooLuganoPage.meta.title',
      description: 'gestionaliOdooLuganoPage.meta.description',
      keywords: 'gestionaliOdooLuganoPage.meta.keywords'
    }
  },
  {
    path: '/social-media-management-ticino',
    name: 'SocialMediaManagementTicinoPage',
    component: SocialMediaManagementTicinoPage,
    meta: {
      title: 'socialMediaManagementTicinoPage.meta.title',
      description: 'socialMediaManagementTicinoPage.meta.description',
      keywords: 'socialMediaManagementTicinoPage.meta.keywords'
    }
  },
  {
    path: '/produzione-video-aziendali-ticino',
    name: 'ProduzioneVideoAziendaliTicinoPage',
    component: ProduzioneVideoAziendaliTicinoPage,
    meta: {
      title: 'produzioneVideoAziendaliTicinoPage.meta.title',
      description: 'produzioneVideoAziendaliTicinoPage.meta.description',
      keywords: 'produzioneVideoAziendaliTicinoPage.meta.keywords'
    }
  },
  {
    path: '/posizionamento-motori-ricerca-lugano',
    name: 'PosizionamentoMotoriRicercaLuganoPage',
    component: PosizionamentoMotoriRicercaLuganoPage,
    meta: {
      title: 'posizionamentoMotoriRicercaLuganoPage.meta.title',
      description: 'posizionamentoMotoriRicercaLuganoPage.meta.description',
      keywords: 'posizionamentoMotoriRicercaLuganoPage.meta.keywords'
    }
  },
  {
    path: '/siti-web-responsive-ticino',
    name: 'SitiWebResponsiveTicinoPage',
    component: SitiWebResponsiveTicinoPage,
    meta: {
      title: 'sitiWebResponsiveTicinoPage.meta.title',
      description: 'sitiWebResponsiveTicinoPage.meta.description',
      keywords: 'sitiWebResponsiveTicinoPage.meta.keywords'
    }
  },
  {
    path: '/digital-marketing-strategie-lugano',
    name: 'DigitalMarketingStrategieLuganoPage',
    component: DigitalMarketingStrategieLuganoPage,
    meta: {
      title: 'digitalMarketingStrategieLuganoPage.meta.title',
      description: 'digitalMarketingStrategieLuganoPage.meta.description',
      keywords: 'digitalMarketingStrategieLuganoPage.meta.keywords'
    }
  },
  {
    path: '/ottimizzazione-seo-locarno',
    name: 'OttimizzazioneSeoLocarnoPage',
    component: OttimizzazioneSeoLocarnoPage,
    meta: {
      title: 'ottimizzazioneSeoLocarnoPage.meta.title',
      description: 'ottimizzazioneSeoLocarnoPage.meta.description',
      keywords: 'ottimizzazioneSeoLocarnoPage.meta.keywords'
    }
  },
  {
    path: '/ecommerce-sviluppo-ticino',
    name: 'EcommerceSviluppoTicinoPage',
    component: EcommerceSviluppoTicinoPage,
    meta: {
      title: 'ecommerceSviluppoTicinoPage.meta.title',
      description: 'ecommerceSviluppoTicinoPage.meta.description',
      keywords: 'ecommerceSviluppoTicinoPage.meta.keywords'
    }
  },
  {
    path: '/web-agency-mendrisio',
    name: 'WebAgencyMendrisioPage',
    component: WebAgencyMendrisioPage,
    meta: {
      title: 'webAgencyMendrisioPage.meta.title',
      description: 'webAgencyMendrisioPage.meta.description',
      keywords: 'webAgencyMendrisioPage.meta.keywords'
    }
  },
  {
    path: '/software-gestionali-bellinzona',
    name: 'SoftwareGestionaliBellinzonaPage',
    component: SoftwareGestionaliBellinzonaPage,
    meta: {
      title: 'softwareGestionaliBellinzonaPage.meta.title',
      description: 'softwareGestionaliBellinzonaPage.meta.description',
      keywords: 'softwareGestionaliBellinzonaPage.meta.keywords'
    }
  },
  {
    path: '/campagne-pubblicitarie-online-ticino',
    name: 'CampagnePubblicitarieOnlineTicinoPage',
    component: CampagnePubblicitarieOnlineTicinoPage,
    meta: {
      title: 'campagnePubblicitarieOnlineTicinoPage.meta.title',
      description: 'campagnePubblicitarieOnlineTicinoPage.meta.description',
      keywords: 'campagnePubblicitarieOnlineTicinoPage.meta.keywords'
    }
  },
  {
    path: '/design-siti-web-lugano',
    name: 'DesignSitiWebLuganoPage',
    component: DesignSitiWebLuganoPage,
    meta: {
      title: 'designSitiWebLuganoPage.meta.title',
      description: 'designSitiWebLuganoPage.meta.description',
      keywords: 'designSitiWebLuganoPage.meta.keywords'
    }
  },
  {
    path: '/seo-consulting-ticino',
    name: 'SeoConsultingTicinoPage',
    component: SeoConsultingTicinoPage,
    meta: {
      title: 'seoConsultingTicinoPage.meta.title',
      description: 'seoConsultingTicinoPage.meta.description',
      keywords: 'seoConsultingTicinoPage.meta.keywords'
    }
  },
  {
    path: '/realizzazione-applicazioni-mobile-locarno',
    name: 'RealizzazioneApplicazioniMobileLocarnoPage',
    component: RealizzazioneApplicazioniMobileLocarnoPage,
    meta: {
      title: 'realizzazioneApplicazioniMobileLocarnoPage.meta.title',
      description: 'realizzazioneApplicazioniMobileLocarnoPage.meta.description',
      keywords: 'realizzazioneApplicazioniMobileLocarnoPage.meta.keywords'
    }
  },
  {
    path: '/gestione-social-media-lugano',
    name: 'GestioneSocialMediaLuganoPage',
    component: GestioneSocialMediaLuganoPage,
    meta: {
      title: 'gestioneSocialMediaLuganoPage.meta.title',
      description: 'gestioneSocialMediaLuganoPage.meta.description',
      keywords: 'gestioneSocialMediaLuganoPage.meta.keywords'
    }
  },
  {
    path: '/video-marketing-ticino',
    name: 'VideoMarketingTicinoPage',
    component: VideoMarketingTicinoPage,
    meta: {
      title: 'videoMarketingTicinoPage.meta.title',
      description: 'videoMarketingTicinoPage.meta.description',
      keywords: 'videoMarketingTicinoPage.meta.keywords'
    }
  },
  {
    path: '/siti-internet-professionali-bellinzona',
    name: 'SitiInternetProfessionaliBellinzonaPage',
    component: SitiInternetProfessionaliBellinzonaPage,
    meta: {
      title: 'sitiInternetProfessionaliBellinzonaPage.meta.title',
      description: 'sitiInternetProfessionaliBellinzonaPage.meta.description',
      keywords: 'sitiInternetProfessionaliBellinzonaPage.meta.keywords'
    }
  },
  {
    path: '/posizionamento-google-mendrisio',
    name: 'PosizionamentoGoogleMendrisioPage',
    component: PosizionamentoGoogleMendrisioPage,
    meta: {
      title: 'posizionamentoGoogleMendrisioPage.meta.title',
      description: 'posizionamentoGoogleMendrisioPage.meta.description',
      keywords: 'posizionamentoGoogleMendrisioPage.meta.keywords'
    }
  },
  {
    path: '/agenzia-marketing-digitale-chiasso',
    name: 'AgenziaMarketingDigitaleChiassoPage',
    component: AgenziaMarketingDigitaleChiassoPage,
    meta: {
      title: 'agenziaMarketingDigitaleChiassoPage.meta.title',
      description: 'agenziaMarketingDigitaleChiassoPage.meta.description',
      keywords: 'agenziaMarketingDigitaleChiassoPage.meta.keywords'
    }
  },
  {
    path: '/sviluppo-software-personalizzati-ticino',
    name: 'SviluppoSoftwarePersonalizzatiTicinoPage',
    component: SviluppoSoftwarePersonalizzatiTicinoPage,
    meta: {
      title: 'sviluppoSoftwarePersonalizzatiTicinoPage.meta.title',
      description: 'sviluppoSoftwarePersonalizzatiTicinoPage.meta.description',
      keywords: 'sviluppoSoftwarePersonalizzatiTicinoPage.meta.keywords'
    }
  },
  {
    path: '/ai-chatbot-development-services-switzerland',
    name: 'AiChatbotDevelopmentServicesSwitzerlandPage',
    component: AiChatbotDevelopmentServicesSwitzerlandPage,
    meta: {
      title: 'aiChatbotDevelopmentServicesSwitzerlandPage.meta.title',
      description: 'aiChatbotDevelopmentServicesSwitzerlandPage.meta.description',
      keywords: 'aiChatbotDevelopmentServicesSwitzerlandPage.meta.keywords'
    }
  },
  {
    path: '/ai-chatbot-switzerland',
    name: 'AiChatbotSwitzerlandPage',
    component: AiChatbotSwitzerlandPage,
    meta: {
      title: 'aiChatbotSwitzerlandPage.meta.title',
      description: 'aiChatbotSwitzerlandPage.meta.description',
      keywords: 'aiChatbotSwitzerlandPage.meta.keywords'
    }
  },
  {
    path: '/web-design-lugano',
    name: 'WebDesignLuganoPage',
    component: WebDesignLuganoPage,
    meta: {
      title: 'webDesignLuganoPage.meta.title',
      description: 'webDesignLuganoPage.meta.description',
      keywords: 'webDesignLuganoPage.meta.keywords'
    }
  },
  {
    path: '/siti-web-avvocati',
    name: 'SitiWebAvvocatiPage',
    component: SitiWebAvvocatiPage,
    meta: {
      title: 'sitiWebAvvocatiPage.meta.title',
      description: 'sitiWebAvvocatiPage.meta.description',
      keywords: 'sitiWebAvvocatiPage.meta.keywords'
    }
  },
  {
    path: '/siti-web-fisioterapia',
    name: 'SitiWebFisioterapiaPage',
    component: SitiWebFisioterapiaPage,
    meta: {
      title: 'Sito Web + Gestionale per Fisioterapisti | 3000 CHF',
      description: 'Sito web professionale e sistema gestionale per studi di fisioterapia. Gestione appuntamenti, schede pazienti e fatturazione. Solo 3000 CHF + 10 CHF/mese.',
      keywords: 'sito web fisioterapia, gestionale fisioterapia, software fisioterapisti, prenotazione appuntamenti fisioterapia'
    }
  },
  {
    path: '/u-table',
    name: 'UTablePage',
    component: UTablePage,
    meta: {
      title: 'U-Table - Sistema di Prenotazione per Ristoranti Worldwide',
      description: 'Il sistema di prenotazione unificato per ristoranti in tutto il mondo. Gestisci prenotazioni, takeaway e flussi di lavoro senza commissioni. Piano Early Bird gratuito per 3 mesi.',
      keywords: 'prenotazione ristoranti, sistema prenotazione, gestione tavoli, prenotazione online ristoranti, restaurant reservation system, table booking system'
    }
  },
  {
    path: '/ai-agent-infrastructure',
    name: 'AiAgentInfrastructurePage',
    component: AiAgentInfrastructurePage,
    meta: {
      title: 'AI Agent Infrastructure — Chatbot, Voice, Automation & Marketing | ciobai.ch',
      description: 'Complete AI infrastructure for Swiss businesses. Chatbot, voice agents, process automation and marketing in one ecosystem. Free prototype. Reduce costs by 90%.',
      keywords: 'ai agent infrastructure, ai chatbot switzerland, voice agents, business automation, ai marketing, ai for SME, ciobai'
    }
  },
  {
    path: '/infrastruttura-ai',
    name: 'InfrastrutturaAiPage',
    component: AiAgentInfrastructurePage,
    meta: {
      title: 'Infrastruttura AI per Aziende — Chatbot, Voce, Automazione & Marketing | ciobai.ch',
      description: 'Infrastruttura AI completa per aziende svizzere. Chatbot, agenti vocali, automazione processi e marketing in un unico ecosistema. Prototipo gratuito. Riduci i costi del 90%.',
      keywords: 'infrastruttura ai, chatbot ai svizzera, agenti vocali, automazione aziendale, marketing ai, ai per PMI, ciobai ticino'
    }
  },
  {
    path: '/ai-infrastructure',
    name: 'AiAgentInfrastructureEnglishPage',
    component: AiAgentInfrastructureEnglishPage,
    meta: {
      title: 'AI Infrastructure for Business — Chatbot, Voice, Automation & Marketing | ciobai.ch',
      description: 'Complete AI infrastructure for businesses. Chatbot, voice agents, process automation and marketing in one ecosystem. Free prototype. Reduce costs by 90%.',
      keywords: 'ai infrastructure, ai chatbot, voice agents, business automation, ai marketing, ai for SME, ciobai'
    }
  },
  {
    path: '/offerta-pmi',
    name: 'OffertaPMIPage',
    component: OffertaPMIPage,
    meta: {
      title: 'Offerta PMI Ticino - Audit Gratuito Processi Aziendali | ciobai.ch',
      description: 'Ottieni clienti qualificati e riduci il lavoro del 50% in 30 giorni o non paghi nulla. Audit gratuito per PMI e Sagl ticinesi. Solo 5 posti al mese.',
      keywords: 'audit processi aziendali, PMI Ticino, Sagl Ticino, automazione aziendale, sito web automatizzato, gestionale aziendale'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    
    return new Promise((resolve) => {
      if (to.hash) {
        // Wait for the component to be rendered
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
            top: 64 // navbar height
          })
        }, 500) // Add a small delay to ensure component is mounted
      } else {
        resolve({ top: 0 })
      }
    })
  }
})

export default router 